<p-toast></p-toast>

<section>
    <div *ngIf="isLoadingCampaign" class="admin-surface">Carregando...</div>

    <div *ngIf="campaign && !isLoadingCampaign">
        <app-admin-page-header [title]="'Detalhes da Campanha ' + campaign.id"
            subtitle="Visualize os detalhes e usuários que receberam essa campanha.">
            <div header-actions>
                <button (click)="goBack()" class="admin-btn admin-btn--secondary">
                    Voltar para a lista
                </button>
            </div>
        </app-admin-page-header>

        <div class="admin-surface__section admin-surface campaign-detail-grid">
            <section>
                <div class="admin-detail-card">
                    <h4>Campanha</h4>
                    <div class="info">
                        <span>Criação</span>
                        <strong>{{campaign.created_at}}</strong>
                    </div>
                    <div class="info">
                        <span>Mensagem</span>
                        <strong>{{campaign.message}}</strong>
                    </div>
                    <div class="info">
                        <span>Imagem</span>
                        <strong>{{campaign.image_url || "N/A"}}</strong>
                    </div>
                    <div class="info">
                        <span>Canais</span>
                        <strong>{{campaign.channels}}</strong>
                    </div>
                    <div class="info no-border">
                        <span>Envios</span>
                        <strong>{{campaign.recipients_count}}</strong>
                    </div>
                </div>
            </section>
            <section>
                <div class="admin-detail-card">
                    <h4>Cluster</h4>
                    <div class="info">
                        <span>ID</span>
                        <strong>{{campaign.cluster.id}}</strong>
                    </div>
                    <div class="info">
                        <span>Nome</span>
                        <strong>{{campaign.cluster.name}}</strong>
                    </div>
                    <div class="info">
                        <span>Descrição</span>
                        <strong>{{campaign.cluster.description || "N/A"}}</strong>
                    </div>
                    <div class="info">
                        <span>Query</span>
                        <p class="campaign-detail-sql">{{campaign.cluster.sql_query}}</p>
                    </div>
                    <div class="info no-border">
                        <span>Usuários</span>
                        <strong>{{campaign.cluster.total_users}}</strong>
                    </div>
                </div>
            </section>
        </div>

        <div class="admin-surface__section admin-surface">
            <div class="admin-surface__header">
                <h3>Usuários</h3>
            </div>
            <div class="admin-detail-card">
                <p-table [value]="recipients" [paginator]="true" [rows]="rowsPerPage" [totalRecords]="totalRecipients"
                    [lazy]="true" [loading]="isLoadingRecipients" (onLazyLoad)="onLazyLoad($event)"
                    styleClass="admin-table">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>ID</th>
                            <th>Nome</th>
                            <th>Username</th>
                            <th>Email</th>
                            <th>Canais</th>
                            <th>Status</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-recipient>
                        <tr>
                            <td>{{recipient.user.id}}</td>
                            <td>{{`${recipient.user.first_name} ${recipient.user.last_name}`}}</td>
                            <td>{{recipient.user.username}}</td>
                            <td>{{recipient.user.email}}</td>
                            <td>{{recipient.channel}}</td>
                            <td>{{recipient.status}}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>


</section>